import { READING_ACTION_TYPES } from '../actions/action_types';

export const initialState = {
  lockedChapterDocument: '',
  isPractice: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK:
      return { ...state, lockedChapterDocument: payload.chapterId || '' };
    case READING_ACTION_TYPES.SET_BOOK_STATE:
      return { ...state, isPractice: payload.isPractice || false };
    default:
      return state;
  }
};
